import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LanguageDropdown from "./LanguageDropdown";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getProfileDataAction, LOGOUT_SUCCESS } from "../redux/auth/auth.actions";
import { socialLogout } from "../firebase";
import { IS_USER_PARTICIPATED_IN_SURVEY_RESET, START_SURVEY_RESET } from "../redux/attemptSurvey/attemptSurvey.actions";
import { toast } from "react-toastify";

export default function Navigation() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("Authorization"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileData } = useSelector((state) => state.authInfo);
  const [showDropdown, setShowDropdown] = useState(false);

  const { startSurveyData } = useSelector((state) => state.attemptSurveyInfo);
  const currentLanguage = localStorage.getItem("language");

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getProfileDataAction());
    }
  }, [dispatch, isLoggedIn]);

  const handleLogout = () => {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("redirectAfterLogin");
    socialLogout();
    setIsLoggedIn(false);
    dispatch({ type: LOGOUT_SUCCESS });
    dispatch({ type: START_SURVEY_RESET });
    dispatch({ type: IS_USER_PARTICIPATED_IN_SURVEY_RESET });
    navigate("/");
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleNavigation = (e, path) => {
    if (startSurveyData?.status) {
      e.preventDefault();
      const message = currentLanguage === "Italian"
        ? "Per favore, completa prima il tuo sondaggio"
        : "Please finish your survey first";
      toast.error(message);
    } else {
      navigate(path);
    }
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-light bg-light" id="navbar">
      <div className="container-fluid">
        <Link className="navbar-brand logo text-uppercase" to="/" onClick={(e) => handleNavigation(e, "/")}>
          <img src="../images/logo-light.png" className="logo-light" alt="Logo Light" height={30} />
          <img src="../images/logo-dark.png" className="logo-dark" alt="Logo Dark" height={30} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="mdi mdi-menu" />
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <ul className="navbar-nav ms-auto" id="navbar-navlist">
            <li className="nav-item"><Link className="nav-link" to="/#home" onClick={(e) => handleNavigation(e, "/#home")}>home</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/#service" onClick={(e) => handleNavigation(e, "/#service")}>servizi</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/#features" onClick={(e) => handleNavigation(e, "/#features")}>funzionalità</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/#download" onClick={(e) => handleNavigation(e, "/#download")}>app</Link></li>
            <li className="nav-item"><a className="nav-link" href="https://magazine.votiamo.com/" target="_blank" rel="noopener noreferrer">{currentLanguage === "Italian" ? "magazine" : "Magazine"}</a></li>
            <li className="nav-item"><Link className="nav-link" to="/sondaggi" onClick={(e) => handleNavigation(e, "/sondaggi")}>sondaggi</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/#faq" onClick={(e) => handleNavigation(e, "/#faq")}>faq</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/#contact" onClick={(e) => handleNavigation(e, "/#contact")}>contatti</Link></li>
            <li className="nav-item dropdown"><LanguageDropdown /></li>
            {isLoggedIn ? (
              <li className="nav-item dropdown" style={{ marginTop: "-6px", position: "relative" }}>
                <div
                  className="nav-link"
                  onClick={toggleDropdown}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={profileData?.data?.image ? `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${profileData?.data?.image}` : "https://cdn.pixabay.com/photo/2021/07/25/08/03/account-6491185_1280.png"}
                    alt="Profile"
                    className="rounded-circle"
                    width={35}
                    height={35}
                  />
                </div>
                {showDropdown && (
                  <ul className="dropdown-menu" style={{
                    position: "absolute",
                    right: 0,
                    top: "100%",
                    display: "block",
                    minWidth: "200px"
                  }}>
                    <li>
                      <span className="dropdown-item disabled">
                        {profileData?.data?.name || (currentLanguage === "Italian" ? "Utente" : "User")}
                      </span>
                    </li>
                    <li>
                      <span className="dropdown-item disabled">
                        {profileData?.data?.email || (currentLanguage === "Italian" ? "Nessuna email" : "No email")}
                      </span>
                    </li>
                    <li><button className="dropdown-item" onClick={handleLogout}>{currentLanguage === "Italian" ? "Disconnettersi" : "Logout"}</button></li>
                  </ul>
                )}
              </li>
            ) : (
              <li className="nav-item" style={{ marginTop: "18px" }}>
                <Link to="/auth">
                  <Button>{currentLanguage === "Italian" ? "Accedi" : "Login"}</Button>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}
